import { portalJson } from '../lib/portalApi';

export type PortalProfile = {
  id: number;
  name: string | null;
  position: string | null;
  phone: string | null;
  email: string | null;
  complexName: string | null;
};

export async function getPortalProfile(): Promise<PortalProfile> {
  const r = await portalJson<PortalProfile>('/api/me/profile', { auth: true });
  if (!r.ok) {
    throw new Error(r.message);
  }
  return r.data;
}

export async function putPortalProfile(body: {
  name?: string;
  phone?: string;
  email?: string;
  complexName?: string;
  position?: string;
}): Promise<void> {
  const r = await portalJson<{ ok?: boolean }>('/api/me/profile', {
    method: 'PUT',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!r.ok) {
    throw new Error(r.message);
  }
}
